import ri from "./trigger-condition.js";
export default class ni {
  constructor(t, i) {
    (this.tf = t), (this.if = i), (this.tf = t), (this.if = i);
  }
  Jl(t) {
    if (null == this.tf) return !1;
    const i = ri.rf(t[0], this.tf);
    if (!i) return !1;
    let r = null == this.if || 0 === this.if.length;
    if (null != this.if)
      for (let i = 0; i < this.if.length; i++)
        if (this.if[i] === t[1]) {
          r = !0;
          break;
        }
    return i && r;
  }
  static fromJson(t) {
    return new ni(t ? t.id : null, t ? t.buttons : null);
  }
  Y() {
    return this.tf;
  }
}
